import { Helmet } from 'react-helmet-async';
// sections
import { ReservationListView } from 'src/sections/reservations';

// ----------------------------------------------------------------------

export default function ReservationListPage() {
  return (
    <>
      <Helmet>
        <title>Reservas | Fleur de Sel</title>
      </Helmet>

      <ReservationListView />
    </>
  );
}
